module.exports = __webpack_public_path__ + "static/media/sound1.7ad935d5.mp3";